import axios from "axios";

// Set config defaults when creating the instance
const instance = axios.create({
  baseURL: `https://api.impactrun.com/web/v1/`,
});

// Alter defaults after instance has been created
// instance.defaults.headers.common[
//   "Authorization"
// ] = `bearer 271c0a26ce3f8a1ba32c4343f3836d5bb0544a93`;

export default instance;
